import { createServiceMutation, createServiceQuery } from "./setup/createService";
import responseGoogleLogin from "./responseHandlers/responseGoogleLogin";
import responseFetchAllVehicles from "./responseHandlers/responseFetchAllVehicles";
import responseAddVehicle from "./responseHandlers/responseAddVehicle";
import responseaddServiceHistory from "./responseHandlers/responseaddServiceHistory";
import responseSignUp from "./responseHandlers/responseSignUp";
import responseSignIn from "./responseHandlers/responseSignIn";
import responseUpdateVehicle from "./responseHandlers/responseUpdateVehicle";
import responseDeleteVehicle from "./responseHandlers/responseDeleteVehicle";
import responseUpdateServiceHistory from "./responseHandlers/responseUpdateServiceHistory";
import responseDeleteServiceHistory from "./responseHandlers/responseDeleteServiceHistory";
import responseUpdateProfile from "./responseHandlers/responseUpdateProfile";
import responseDeleteAccount from "./responseHandlers/responseDeleteAccount";
import responseFetchNotifications from "./responseHandlers/responseFetchNotifications";
import responseFetchHeaderNotifications from "./responseHandlers/responseFetchHeaderNotifications";
import responseFetchAllServiceHistories from "./responseHandlers/responseFetchAllServiceHistories";

// Response handlers for notification read status
const responseMarkNotificationRead = () => {};

// Simple response handlers for new endpoints
const responseForgotPassword = () => ({});
const responseResetPassword = () => ({});
const responseContactUs = () => ({});

export const googleLogin = createServiceMutation(responseGoogleLogin);
export const addVehicle = createServiceMutation(responseAddVehicle);
export const addServiceHistory = createServiceMutation(responseaddServiceHistory);
export const fetchAllVehicles = createServiceQuery(responseFetchAllVehicles);
export const fetchAllServiceHistories = createServiceQuery(responseFetchAllServiceHistories);
export const signUp = createServiceMutation(responseSignUp);
export const signIn = createServiceMutation(responseSignIn);
export const updateVehicle = createServiceMutation(responseUpdateVehicle);
export const deleteVehicle = createServiceMutation(responseDeleteVehicle);
export const updateServiceHistory = createServiceMutation(responseUpdateServiceHistory);
export const deleteServiceHistory = createServiceMutation(responseDeleteServiceHistory);
export const updateProfile = createServiceMutation(responseUpdateProfile);
export const deleteAccount = createServiceMutation(responseDeleteAccount);
export const fetchNotifications = createServiceQuery(responseFetchNotifications);
export const fetchHeaderNotifications = createServiceQuery(responseFetchHeaderNotifications);
export const markNotificationRead = createServiceMutation(responseMarkNotificationRead);
export const markAllNotificationsRead = createServiceMutation(responseMarkNotificationRead);

// New endpoints
export const forgotPassword = createServiceMutation(responseForgotPassword);
export const resetPassword = createServiceMutation(responseResetPassword);
export const contactUs = createServiceMutation(responseContactUs);
